import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { ConstructionEquipment } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  constructionEquipment: ConstructionEquipment;
}

const ConstructionEquipmentDetails: React.FC<Props> = ({ constructionEquipment }) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        {constructionEquipment.isFuelData ? (
          <>
            <colgroup>
              <col style={{ width: '30%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '30%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th>{t('Transportation Fuel')}</th>
                <th>{t('Quantity of Fuel Used ')}</th>
                <th>{parse(t('Default CO<sub>2</sub> Emission Factor'))}</th>
                <th>{parse(t('CO<sub>2</sub> Emissions'))}</th>
              </tr>
            </thead>
            <tbody>
              {constructionEquipment.fuelDataRows.map((row) => (
                <tr key={row.id}>
                  <td>{row.fuelType}</td>
                  <td>
                    <NumberFormatterSinSeparador value={row.value} />
                  </td>
                  <td>
                    <NumberFormatterSinSeparador value={row.factor} />
                  </td>
                  <td>
                    <NumberFormatterSinSeparador value={row.totalEmission} />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="subtotal-column-left">Subtotal:</td>
                {/* espaciador intencional, sin contenido */}
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <td colSpan={2} />
                <td className="subtotal-column-left">
                  <NumberFormatterSinSeparador value={constructionEquipment.subTotal} /> t CO
                  <sub>2</sub>
                </td>
              </tr>
            </tfoot>
          </>
        ) : (
          <>
            <colgroup>
              <col style={{ width: '25%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '13%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '13%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '13%' }} />
            </colgroup>
            <thead>
              <tr>
                <th>Vehicle Type</th>
                <th>
                  CO<sub>2</sub> Emissions
                </th>
                <th>
                  t CO<sub>2</sub>
                </th>
                <th>CH4 Emissions</th>
                <th>t CH4</th>
                <th>N2O Emissions</th>
                <th>t N20</th>
              </tr>
            </thead>
            <tbody>
              {constructionEquipment.vehicleDataRows.map((row) => (
                <tr key={row.id}>
                  <td>{row.vehicleType}</td>
                  <td>
                    <NumberFormatterSinSeparador value={row.co2Factor} />
                  </td>
                  <td>
                    <NumberFormatterSinSeparador value={row.co2Emission} />
                  </td>
                  <td>
                    {row.ch4Emission ? (
                      <NumberFormatterSinSeparador value={row.ch4Factor} />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    <NumberFormatterSinSeparador value={row.ch4Emission ? row.ch4Emission : 0} />
                  </td>
                  <td>
                    {row.n2OFactor ? <NumberFormatterSinSeparador value={row.n2OFactor} /> : 'N/A'}
                  </td>
                  <td>
                    <NumberFormatterSinSeparador value={row.n2OEmission ? row.n2OEmission : 0} />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="subtotalDetail subtotal-column-left">Subtotal:</td>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <td />
                <td className="subtotal-column-left">
                  <NumberFormatterSinSeparador value={constructionEquipment.co2Total} /> t CO
                  <sub>2</sub>
                </td>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <td />
                <td className="subtotal-column-left">
                  <NumberFormatterSinSeparador value={constructionEquipment.ch4Total} /> t CH4
                </td>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <td />
                <td className="subtotal-column-left">
                  <NumberFormatterSinSeparador value={constructionEquipment.n2OTotal} /> t N20
                </td>
              </tr>
            </tfoot>
          </>
        )}
      </Table>
    </div>
  );
};

export default ConstructionEquipmentDetails;
